module.exports = __webpack_public_path__ + "static/media/PartnerTomTomLogo.b9ee231a.png";